import { Component, Output, EventEmitter } from '@angular/core';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { HandrailDisplayService } from '../services/handrail-display.service';
import { DockModeService } from '../services/dock-mode.service';

@Component({
  selector: 'app-step2-list',
  templateUrl: './step2-list.component.html',
  styleUrls: ['./step2-list.component.scss']
})
export class Step2ListComponent {

  @Output() step2Editer = new EventEmitter();
  toggleRailing = true;
  railingType = '';
  step2Edited(value) {
    this.step2Editer.emit({ name: value });
    if('addStairHandrail'){
      this.handrailDisplayService.checkTiersStairsOnStage();
    }
  }

  constructor(
    private railingGeneration: RailingGenerationService,
    private handrailDisplayService: HandrailDisplayService,
    public dockMode: DockModeService,
    private dataForMenu: DataForDisplayingMenuItemsService
  ) {
    this.railingGeneration.railingToggleUpdate.subscribe(value =>{
      this.toggleRailing = value;
    })
    this.dataForMenu.railingType.subscribe(value => {
      this.railingType = value;
    });
  }

  generateRailing(toggleRailing: boolean) {
    this.railingGeneration.buildRailing(!toggleRailing);
  }

}



// WEBPACK FOOTER //
// ./src/app/step2-list/step2-list.component.ts